import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/superadmin.css';

const BASE = 'https://menu.searchisend.in';

const SuperadminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading]   = useState(false);
    const [error, setError]       = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const res = await fetch(`${BASE}/apimenu/v2/v2_super_login.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });

            const data = await res.json();
            if (data.success) {
                localStorage.setItem('saas_superadmin_token', data.token);
                localStorage.setItem('saas_superadmin_user', JSON.stringify(data.admin));
                navigate('/superadmin_v2_secure');
            } else {
                if (data.chances_left !== undefined && data.chances_left > 0) {
                    setError(`${data.message} ${data.chances_left} attempts remaining.`);
                } else {
                    setError(data.message || 'Login failed.');
                }
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="sa-auth-wrapper">
            <div className="sa-auth-brand">
                <div className="sa-auth-content">
                    <div className="sa-logo-icon" style={{ width: '80px', height: '80px', fontSize: '2.5rem', margin: '0 auto 2rem auto' }}>
                        S
                    </div>
                    <h1 style={{ fontSize: '3rem', fontWeight: 800, margin: '0 0 1rem 0', letterSpacing: '-0.02em' }}>
                        SIE <span className="sa-text-gradient">QR Menu</span>
                    </h1>
                    <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary)', maxWidth: '400px', margin: '0 auto', lineHeight: 1.6 }}>
                        Super Admin Panel. Monitor performance, manage partners, and configure platform settings.
                    </p>
                </div>
            </div>
            
            <div className="sa-auth-form-container">
                <div className="sa-auth-form" style={{ width: '100%' }}>
                    <div style={{ marginBottom: '3rem' }}>
                        <h2 style={{ fontSize: '1.8rem', fontWeight: 700, margin: '0 0 0.5rem 0' }}>Welcome back</h2>
                        <p style={{ color: 'var(--text-secondary)', margin: 0 }}>Sign in to the superadmin panel.</p>
                    </div>
                    
                    {error && (
                        <div style={{ padding: '12px', background: 'var(--danger-bg)', color: 'var(--danger)', border: '1px solid rgba(239, 68, 68, 0.2)', borderRadius: 'var(--radius-sm)', marginBottom: '1.5rem', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fas fa-exclamation-circle"></i> {error}
                        </div>
                    )}

                    <form onSubmit={handleLogin}>
                        <div className="sa-form-group">
                            <label className="sa-form-label">Username</label>
                            <input
                                type="text"
                                required
                                className="sa-input"
                                style={{ width: '100%' }}
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Enter admin username"
                            />
                        </div>
                        
                        <div className="sa-form-group" style={{ marginBottom: '2rem' }}>
                            <label className="sa-form-label">Password</label>
                            <input
                                type="password"
                                required
                                className="sa-input"
                                style={{ width: '100%' }}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                            />
                        </div>

                        <button 
                            type="submit" 
                            disabled={loading}
                            className="sa-primary-btn"
                            style={{ width: '100%', padding: '14px', fontSize: '1rem', display: 'flex', justifyContent: 'center' }}
                        >
                            {loading ? (
                                <><i className="fas fa-circle-notch fa-spin"></i> Authenticating...</>
                            ) : (
                                <>Sign In <i className="fas fa-arrow-right"></i></>
                            )}
                        </button>
                        
                        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                             <Link to="/login" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.2s' }} onMouseEnter={(e) => e.target.style.color = 'var(--text-primary)'} onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}>
                                &larr; Back to Regular Restaurant Login
                             </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SuperadminLogin;
